/**
 * Checks if the element is scrollable.
 * @return [Boolean] True if the passed in element is scrollable.
 * @link https://htmldom.dev/check-if-an-element-is-scrollable/
 */
export function isScrollable(ele) {
    // Compare the height to see if the element has scrollable content
    const hasScrollableContent = ele.scrollHeight > ele.clientHeight;

    // It's not enough because the element's `overflow-y` style can be set as
    // * `hidden`
    // * `hidden !important`
    // In those cases, the scrollbar isn't shown
    const overflowYStyle = window.getComputedStyle(ele).overflowY;
    const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

    return hasScrollableContent && !isOverflowHidden;
}


export function isElementScrolledToEnd(element) {
    if (!isScrollable(element)) return true; // When the element is not scrollable then it is considered to be scrolled to the end.

    // Check if the element is scrolled to the end of its content
    return element.scrollTop >= (element.scrollHeight - element.clientHeight);
}
